"use strict";

function formatUrl(url) {
  var httpString = "http://",
      httpsString = "https://";
  if (url.substr(0, httpString.length) !== httpString && url.substr(0, httpsString.length) !== httpsString) url = httpsString + url;
  return url;
}

const $trialFormModal = $('.page-with-trial-form');
const TRIAL_FORM_SECTION_SELECTOR = ".form-trial__section";
let currentActiveStepNumber = 1;

$.fn.trialForm = function () {
  let $this = $(this);
  let $form = $this.find("#trial-form");
  let $sections = $form.find(TRIAL_FORM_SECTION_SELECTOR);
  let $sectionButtonSelectorPrev = $(".trial-form__button-prev");
  let sectionButtonSelector = ".trial-form__button";
  let formItem = ".trial-form__list-item";
  let inputWrapper = ".trial-form__input-wrapper";
  $(window).keypress(function (e) {
    let key = e.which;
    const isOpenedTrialForm = $trialFormModal.css('display') === 'block';

    if (key === 13 && isOpenedTrialForm) {
      let currentSection = $($sections[currentActiveStepNumber - 1]);
      let nextButton = currentSection.find(sectionButtonSelector);
      nextButton.click();

      if (nextButton.length === 0) {
        goNextStep();
      }

      return false;
    }
  });

  validate.validators.emailDomain = function (value, attributes, key) {
    let [, domain] = value.split('@');
    const RESTRICTED_DOMAINS = ['gmail.com', 'yahoo.com', 'yandex.com', 'mac.com', 'yandex.ru', 'hotmail.com', 'me.com', 'fb.com', 'facebook.com', 'outlook.com', 'msn.com'];

    if (RESTRICTED_DOMAINS.includes(domain)) {
      showErrorMessage($form, inputWrapper, value, key, "Please enter your business email");
      return "^Please enter your business email";
    }

    return null;
  };

  let constraints = {
    helpcenter_url: {
      presence: {
        allowEmpty: false,
        message: function (value, attribute) {
          showErrorMessage($form, inputWrapper, value, attribute, "Please fill this in");
        }
      },
      url: {
        message: function (value, attribute) {
          showErrorMessage($form, inputWrapper, value, attribute, "Hmm…that web address doesn't exist");
        }
      }
    },
    email: {
      presence: {
        allowEmpty: false,
        message: function (value, attribute) {
          showErrorMessage($form, inputWrapper, value, attribute, "Please fill this in");
        }
      },
      email: {
        message: function (value, attribute) {
          showErrorMessage($form, inputWrapper, value, attribute, "Hmm…that email doesn't look valid");
        }
      },
      emailDomain: {}
    }
  };
  $(document).ready(function () {
    $sectionButtonSelectorPrev.click(function () {
      goPrevStep();
    });
    $('[name="helpcenter_url"]').blur(function () {
      let currentURL = $(this).val();

      if (currentURL) {
        $(this).val(formatUrl(currentURL));
      }
    }).keypress(function (e) {
      let key = e.which;

      if (key === 13) {
        let currentURL = $(this).val();

        if (currentURL) {
          $(this).val(formatUrl(currentURL));
        }
      }
    });
    $form.find(sectionButtonSelector).click(function (e) {
      let $button = $(e.target);
      let $inputsContainer = $button.closest(inputWrapper);
      let isSubmitBtn = $button.is(':submit');
      let values = getValues($form);
      let errors = validate(values, constraints);

      if (!isSubmitBtn) {
        if (errors) {
          Object.entries(errors).forEach(([key]) => {
            $form.find(`input[name="${key}"]`).closest(inputWrapper).addClass("has-errors");
          });
        } else {
          $inputsContainer.addClass("validated").removeClass("has-errors");
          goNextStep();
        }
      }
    });
    $form.find(".trial-form__input").change(function (e) {
      let wrapper = $(e.target).closest(inputWrapper);
      $(wrapper).removeClass("has-errors");
    });
    $form.submit(function (event) {
      event.preventDefault();
      let orgid = $form.find("input[name='orgid']").val();
      let retURL = "https://";
      let priority = $form.find("input[name='priority']").val();
      let status = $form.find("input[name='status']").val();
      let origin = $form.find("input[name='origin']").val();
      let location = window.location.href;
      let values = getValues($(this));
      let roistat = ZDT.getCookie("roistat_visit");
      let captcha_settings = $form.find("input[name='captcha_settings']").val();
      let recaptchaResponse = grecaptcha.getResponse();
      let hiddenRecaptcha = $form.find("input[name='hiddenRecaptcha']").val();

      if (!values.theme) {
        return false;
      }

      if (!formTrialRecaptchaSubmitFlag) {
        $form.find(":submit").closest(formItem).addClass("has-errors");
        return false;
      }

      $form.find(":submit").closest(formItem).removeClass("has-errors");
      let description = Object.entries(values).reduce((acc, [key, value]) => {
        let label = $(this).find(`*[data-input-label="${key}"]`).text().trim().replace("*", "");
        let printValue = !value || value.length === 0 ? "_" : value;

        if (label) {
          acc += label + "\n" + printValue + "\n\n";
        }

        return acc;
      }, "");
      let details = Object.assign({}, {
        captcha_settings: captcha_settings,
        orgid: orgid,
        retURL: retURL,
        priority: priority,
        status: status,
        origin: origin,
        "00N1n00000SZMvN": location,
        "00N1n00000T8LpC": 1,
        "00N1n00000TT9eY": roistat,
        description: description,
        subject: "Get Trial Link",
        submit: "Submit",
        hiddenRecaptcha: hiddenRecaptcha,
        "g-recaptcha-response": recaptchaResponse
      }, values);
      let formBody = [];

      for (let property in details) {
        let encodedKey = encodeURIComponent(property);
        let encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
      }

      formBody = formBody.join("&");
      let url = "https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8";
      fetch(url, {
        method: "Post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        mode: "no-cors",
        body: formBody
      }).then(response => {
        return response;
      });
      $("html, body").removeClass("trial-form-open");
      $trialFormModal.hide();
      analytics.identify(null, {
        email: values.email
      });
      analytics.track('TryATheme');
      $(this)[0].reset();
      window.open(configureUrlToRedirect(values.helpcenter_url, values.theme), '_blank').focus();
    });
  });
};

$trialFormModal.trialForm();

function getValues(values) {
  var namesToFilter = {
    captcha_settings: 1,
    orgid: 1,
    retURL: 1,
    priority: 1,
    status: 1,
    origin: 1,
    hiddenRecaptcha: 1,
    "00N1n00000SZMvN": 1,
    "00N1n00000T8LpC": 1,
    "g-recaptcha-response": 1
  };
  return values.serializeArray().filter(item => {
    if (!namesToFilter[item.name]) {
      return item;
    }
  }).reduce((acc, item) => {
    if (!acc[item.name]) {
      acc[item.name] = item.value !== '' ? item.value : null;
    } else {
      acc[item.name] += ", " + item.value;
    }

    return acc;
  }, {});
}

function showErrorMessage(container, item, value, attribute, message) {
  var finalMessage = value === null ? "Please fill this in" : message;
  container.find(`input[name="${attribute}"]`).closest(item).find('.trial-form__error-message').text(finalMessage);
}
/*eslint-disable */


var formTrialRecaptchaSubmitFlag = false;

var formTrialRecaptchaVerifyCallback = function () {
  formTrialRecaptchaSubmitFlag = true;
};

var formTrialRecaptchaExpiredCallback = function () {
  formTrialRecaptchaSubmitFlag = false;
};

var formTrialRecaptchaErrorCallback = function () {
  formTrialRecaptchaSubmitFlag = false;
};
/*eslint-enable */


function openGetTrialPopup() {
  $("html, body").addClass("trial-form-open");
  $("#trial-form").removeClass("hidden");
  $trialFormModal.css("display", "block");
}

function closeTrialModalOnOutsideClick(e) {
  let $modalTrial = $('[data-trial-form-modal]');
  let $cookies = $('[data-cookies-bar]');
  let isOpenedPopup = $trialFormModal.css('display') === 'block';

  if (isOpenedPopup && !$modalTrial.is(e.target) && $modalTrial.has(e.target).length === 0 && !$cookies.is(e.target) && $cookies.has(e.target).length === 0) {
    $("html, body").removeClass("trial-form-open");
    $trialFormModal.hide();
    moveToStep(1);
  }
}

function moveToStep(stepNumber) {
  let $trialForm = $('#trial-form');
  $trialForm.find('[data-form-step]').removeClass('active');
  $trialForm.find(`[data-form-step="${stepNumber}"]`).addClass('active');
  currentActiveStepNumber = stepNumber;
}

function goNextStep() {
  return moveToStep(currentActiveStepNumber + 1);
}

function goPrevStep() {
  return moveToStep(currentActiveStepNumber - 1);
} // "Try a theme" button


$("[data-get-trial]").click(function (e) {
  e.stopPropagation();
  openGetTrialPopup();
  $(document).click(function (e) {
    closeTrialModalOnOutsideClick(e);
  });
});

function extractDomain(helpcenterUrl) {
  const {
    hostname
  } = new URL(helpcenterUrl);
  return hostname;
}

function configureUrlToRedirect(helpcenterUrl, theme) {
  let redirectTemplate = 'https://[SUBDOMAIN]/theming/workbench/marketplace/[THEME_ID]';
  const THEME_IDS = {
    Flatrock: 9,
    Mink: 11,
    Hudson: 12,
    Selway: 72,
    Conway: 85,
    "Lotus One": 13,
    Braden: 10,
    Delta: 102,
    Oyster: 101
  };
  let domain = extractDomain(helpcenterUrl);
  return redirectTemplate.replace('[SUBDOMAIN]', domain).replace('[THEME_ID]', THEME_IDS[theme]);
}

$("[data-trial-form-cancel]").click(function () {
  $("html, body").removeClass("trial-form-open");
  moveToStep(1);
  $trialFormModal.hide();
});

if (window.location.hash) {
  var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character

  if (hash === 'tryatheme') {
    openGetTrialPopup();
  }
}

let $bundlesBanner = $("[for='theme-bundles']");

if ($(".quote-form__toggle-label").has($bundlesBanner)) {
  $bundlesBanner.remove();
}